import * as Tone from "tone";

// de-couple and existing libs that need to check for AudioContext start from Tone
export default function getAudioContext() {
  return Tone.getContext();
}